import ReactGA from "react-ga";
import env from "./env";

const TRACKING_ID = env("REACT_APP_GA_UAID");

function init() {
  const isDev = env("NODE_ENV") !== "production";
  ReactGA.initialize(TRACKING_ID, { debug: isDev, testMode: isDev });
}

function sendEvent(payload: any) {
  ReactGA.event(payload);
}

function sendPageview(path: string) {
  ReactGA.set({ page: path });
  ReactGA.pageview(path);
}

export default {
  init,
  sendEvent,
  sendPageview,
};
